import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Grid, Typography, Card, TableContainer, Table, TableRow, TableCell, TableBody, Checkbox, FormControlLabel, Autocomplete } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import AddIcon from "@mui/icons-material/Add";

import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditLiners() {
  const history = useHistory();
  let { id } = useParams();
  const data_params = { id: id };
  const EmpId = localStorage.getItem("EmpId");
  const classes = useStyles();

  const [LinersStatus, setLinersStatus] = useState(1);
  const [LinersName, setLinersName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [tel, setTel] = useState("");
  const [mac5code, setMAC5Code] = useState("");
  const [contact, setContact] = useState("");
  const [LinersNo, setLinersNo] = useState("");
  const [ModId, setModId] = useState("1");
  const [Submitting, setSubmitting] = useState(false);
  const [MasterCost, setMasterCost] = useState([])
  const [vat, setVat] = useState([])
  const [currency, setCurrency] = useState([]);

  const [ErrLinersName, setErrLinersName] = useState(false);
  const [ErrLinersNo, setErrLinersNo] = useState(false);
  const [rows, setRows] = useState([]);
  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      CostId: "",
      CostPrice: 0,
      CurrencyId: "",
      CostPerContainer: true
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {

    const data = rows?.filter((e, id) => i !== id);
    setRows(data);
  };
  const getData = async () => {
    try {
      await api
        .post("api/liners/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              setLinersName(res.LinersName);
              setLinersNo(res.LinersNo);
              setModId(res.ModID);
              setMAC5Code(res.LinersMAC5Code)
              setAddress(res.LinersAddress)
              setContact(res.LinersContactName)
              setEmail(res.LinersEmail)
              setTel(res.LinersTel)
              // res.Status.data.map((res) => {
              //   setLinersStatus(res);
              // });
              setRows(res.LinersCostDetails)
              setLinersStatus(res.Status === true ? 1 : 0);
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/Liners");
                }
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const addData = async () => {
    const data = {
      no: LinersNo,
      name: LinersName,
      status: LinersStatus,
      createId: EmpId,
      LinersCostDetails: rows,
      LinersMAC5Code: mac5code,
      LinersAddress: address,
      LinersContactName: contact,
      LinersEmail: email,
      LinersTel: tel


    };

    if (!LinersName || !LinersNo) {
      if (!LinersName) {
        setErrLinersName(true);
      } else if (!LinersNo) {
        setErrLinersNo(true);
      }
    } else {
      api
        .post("api/liners/create", data)
        .then((respose) => {
          const MySwal = withReactContent(Swal);

          MySwal.fire({
            icon: "success",
            didOpen: () => {
              MySwal.clickConfirm();
            },
          }).then(() => {
            return MySwal.fire(
              "สำเร็จ!",
              "เพิ่มสายการเดินเรือ !",
              "success"
            ).then((result) => {
              if (result.isConfirmed) {
                history.push("/Setting/Liners");
              }
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // alert(JSON.stringify(data, null, 2));
    setSubmitting(false);
  };

  const editData = async () => {
    const data = {
      id: id,
      no: LinersNo,
      name: LinersName,
      status: LinersStatus,
      ModId: EmpId,
      LinersMAC5Code: mac5code,
      LinersAddress: address,
      LinersContactName: contact,
      LinersEmail: email,
      LinersTel: tel,
      LinersCostDetails: rows
    };

    if (!LinersName || !LinersNo) {
      if (!LinersName) {
        setErrLinersName(true);
      } else if (!LinersNo) {
        setErrLinersNo(true);
      }
    } else {
      api
        .post("api/liners/update", data)
        .then((respose) => {
          const MySwal = withReactContent(Swal);

          MySwal.fire({
            icon: "success",
            didOpen: () => {
              MySwal.clickConfirm();
            },
          }).then(() => {
            return MySwal.fire(
              "สำเร็จ!",
              "แก้ไขสารการเดินเรือ !",
              "success"
            ).then((result) => {
              if (result.isConfirmed) {
                history.push("/Setting/Liners");
              }
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // alert(JSON.stringify(data, null, 2));
    setSubmitting(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id) {
      editData();
    } else {
      addData();
    }
  };

  useEffect(() => {
    if (id) {
      getData();
    }
    const getMasterCost = async () => {
      try {
        const res = await api.get(`/api/master/cost/Sale%20Order%20Cost`);
        setMasterCost(res?.data);

        //   setLog_data_length(3);
      } catch (e) {
        console.log(e);
      }
    };
    const getCurrency = async () => {
      try {
        const res = await api.get(`api/master/currency`);
        setCurrency(res?.data);

        //   setLog_data_length(3);
      } catch (e) {
        console.log(e);
      }
    };
    getCurrency()
    getMasterCost()
  }, []);

  return (
    <div>
      <Card
        variant="outlined"
        style={{ padding: "20px", margin: "25px", minHeight: "86vh" }}
      >
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          สายการเดินเรือ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Liners
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Liners
            </Typography>
          </Grid>
        </Grid>

        <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
            สายกายเดินเรือ
          </h6>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="NameLiners"
                label="Name Liners"
                variant="outlined"
                placeholder="Enter Name Liners"
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setLinersName(e.target.value);
                  setErrLinersName(false);
                }}
                error={ErrLinersName}
                InputLabelProps={{ shrink: true }}
                value={LinersName}
                classes={{ root: !LinersName ? classes.customOutline : null }}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}></Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Liners Code."
                InputLabelProps={{ shrink: true }}
                placeholder="Enter Liners Code."
                name="LinersNO"
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setLinersNo(e.target.value);
                  setErrLinersNo(false);
                }}
                error={ErrLinersNo}
                value={LinersNo}
              />
              {/* {errors.polpod_no && touched.polpod_no && errors.polpod_no} */}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="MAC5"
                label="MAC-5 Code "
                variant="outlined"
                placeholder="Enter MAC-5 Code "
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setMAC5Code(e.target.value);
                }}
                InputLabelProps={{ shrink: true }}
                value={mac5code}

              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}></Grid>

            <Grid item xs={12} sm={6} md={6}>
              <TextField
                name="Address"
                label="Address"
                variant="outlined"
                placeholder="Enter Address"
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setAddress(e.target.value)
                }}
                InputLabelProps={{ shrink: true }}
                value={address}

              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}></Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="Contact"
                label="Contact Name"
                variant="outlined"
                placeholder="Enter Contact Name"
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setContact(e.target.value);
                }}
                InputLabelProps={{ shrink: true }}
                value={contact}

              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="Email"
                label="Email"
                variant="outlined"
                placeholder="Enter Email"
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                InputLabelProps={{ shrink: true }}
                value={email}

              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}></Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                name="Telephone"
                label="Telephone"
                variant="outlined"
                placeholder="Enter Telephone"
                style={{
                  width: "100%",

                }}
                onChange={(e) => {
                  setTel(e.target.value);
                }}
                InputLabelProps={{ shrink: true }}
                value={tel}

              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>

              <FormControl fullWidth>
                <InputLabel id="select_status-label">Status</InputLabel>
                <Select
                  name="select_status"
                  id="select_status"
                  value={LinersStatus}
                  label="Status"
                  style={{
                    width: "100%",

                  }}
                  onChange={(e) => setLinersStatus(e.target.value)}
                >
                  <MenuItem value={1}>Active</MenuItem>
                  <MenuItem value={0}>InActive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Button
            type="button"
            variant="contained"
            // disabled={costType ? false : true}
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginTop: "10px",
            }}
            onClick={addRow}
          >
            <AddIcon /> Add
          </Button>
          <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
            <Table stickyHeader>
              <TableRow>
                <TableCell align="center" width="5%">#</TableCell>
                <TableCell align="center" width="15%">Charge</TableCell>
                <TableCell align="center" width="10%">Quantity</TableCell>
                <TableCell align="center" width="15%">Price</TableCell>
                <TableCell align="center" width="10%">Currency</TableCell>

                {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                <TableCell align="center" width="10%"></TableCell>
              </TableRow>
              {rows?.map((data, index) => {
                return (
                  <TableBody key={index}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="center">
                      {/* <FormControl fullWidth>
                        <InputLabel>Charge</InputLabel>
                        <Select
                          label="Charge"
                          value={data?.CostId || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            const io = rows?.map((v) => {
                              v.CostId =
                                v?.id === data?.id ? e.target.value : v?.CostId;
                              v.Cost =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value) : v?.Cost;
                              v.CostPrice =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CostPrice : +v?.CostPrice;
                              v.CurrencyId =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CurrencyId : v?.CurrencyId;

                              return v;
                            });

                            setRows([...io]);
                          }}
                        >
                          {MasterCost?.map((x) =>
                            <MenuItem value={x?.CostId}>{x?.CostName}</MenuItem>
                          )}
                        </Select>
                      </FormControl> */}
                      <Autocomplete
                        // freeSolo
                        fullWidth
                        options={MasterCost}
                        getOptionLabel={(option) => option?.CostName}
                        // renderOption={(props, option) => (
                        //   <Box component="li" {...props} key={option.EmpNo}>
                        //     {option?.firstname} {option?.lastname}</Box>
                        // )}

                        id="controlled-demo"
                        value={data?.Cost}
                        onChange={(event, newValue) => {

                          const io = rows?.map((v) => {
                            v.Cost =
                              v?.id === data?.id ? newValue : v?.Cost;
                            v.CostId =
                              v?.id === data?.id ? newValue?.CostId : v?.CostId;
                            v.Cost =
                              v?.id === data?.id ? MasterCost.find(x => x?.CostId === newValue?.CostId) : v?.Cost;
                            v.CostPrice =
                              v?.id === data?.id ? MasterCost.find(x => x?.CostId === newValue?.CostId)?.CostPrice : +v?.CostPrice;
                            v.CurrencyId =
                              v?.id === data?.id ? MasterCost.find(x => x?.CostId === newValue?.CostId)?.CurrencyId : v?.CurrencyId;

                            return v;
                          });

                          setRows([...io]);                        }}

                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        renderInput={(params) => (
                          <TextField {...params} label="Charge" />
                        )}
                      />
                    </TableCell>


                    <TableCell align="center">


                      <FormControlLabel control={<Checkbox
                        checked={
                          data?.CostPerContainer || ''
                        }

                        onChange={(e) => {
                          const io = rows?.map((v) => {
                            v.CostPerContainer =
                              v?.id === data?.id ? e.target.checked : v?.CostPerContainer;

                            return v;
                          });

                          setRows([...io]);
                        }} />} label="per CNTR" />

                    </TableCell>
                    <TableCell align="center">
                      <TextField
                        label="Price"
                        value={data?.CostPrice || ''}
                        type='number'
                        onChange={(e) => {
                          const io = rows?.map((v) => {
                            v.CostPrice =
                              v?.id === data?.id ? +e.target.value : +v?.CostPrice;

                            return v;
                          });

                          setRows([...io]);
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <FormControl fullWidth>
                        <InputLabel>Currency</InputLabel>
                        <Select
                          label="Currency"
                          value={data?.CurrencyId || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            const io = rows?.map((v) => {
                              v.CurrencyId = v?.id === data?.id ? e.target.value : v?.CurrencyId;

                              return v;
                            });

                            setRows([...io]);
                          }}
                        >
                          {currency?.map((x) =>
                            <MenuItem value={x?.CurrencyId}>{x?.CurrencyCode}</MenuItem>

                          )}
                        </Select>
                      </FormControl>
                    </TableCell>




                    <TableCell align="center">
                      <Button
                        type="button"
                        variant="outlined"
                        style={{
                          color: "#80c340",
                          borderColor: "#80c340",
                        }}
                        onClick={() => deletehand(index)}
                      >
                        Delete
                      </Button>
                    </TableCell>
                  </TableBody>
                );
              })}

            </Table>
          </TableContainer>
          <Button
            type="button"
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={history.goBack}
          >
            back
          </Button>
          <Button
            type="submit"
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            disabled={Submitting}
          >
            {Submitting && <CircularProgress size={22} />}
            {!Submitting && "SAVE"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
